import Index from './index.vue'
import Create from './components/Create.vue'
import OpenInvoice from './views/OpenInvoice.vue'
import PassedDue from './views/PassedDue.vue'
// import MissingSerailNumber from './views/MissingSerailNumber.vue'
import ManualCharge from './views/ManualCharge.vue'
import ReadyToBeMade from './views/ReadyToBeMade.vue'
import Edit from './components/Edit.vue'
import List from '@/modules/Invoice/views/List.vue'

export default [
  {
    path: 'invoice',
    name: 'invoice',
    component: Index,
    title: 'Invoice',
    redirect: { name: 'open-invoice-list' },
    children: [
      {
        path: 'list',
        name: 'List',
        component: List,
      },
      {
        path: 'manualCharge',
        name: 'manual-charge',
        component: ManualCharge,
      },
      {
        path: 'readyToBeMade',
        name: 'ready-to-be-made-invoice',
        component: ReadyToBeMade,
      },
      {
        path: 'openInvoice',
        name: 'open-invoice-list',
        component: OpenInvoice,
      },
      {
        path: 'passedDue',
        name: 'passed-due-invoice-list',
        component: PassedDue,
      },
      {
        path: ':id/create',
        name: 'invoice-create',
        component: Create,
      },
      {
        path: 'edit/:id',
        name: 'invoice-edit',
        component: Edit,
      },
    ],
  },
]
